import React, { Children, useEffect, useRef, useState } from 'react';
import * as rsuite from 'rsuite';

import Layout from '../../Layout/PrivateLayout.js';
import * as General from '../General/General.js';
import { trackPromise } from 'react-promise-tracker';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import * as BiIcon from "react-icons/bi";
import moment from 'moment-jalaali';
import DatePicker from 'react-datepicker2';
import TimePicker from 'react-time-picker';
import PN from "persian-number";
import Drp_Bank from '../Bank/Drp_Bank.js';
import Drp_Fund from '../Fund/Drp_Fund.js';
import Drp_CheckBookPage from '../Bank/Drp_CheckBookPage.js';
import Auto_CheckInFound from '../RecieptReceivd/Auto_CheckInFound.js';
import Drp_DocSetting from '../AccountDocSettings/Drp_DocSetting.js';
import Auto_ACCC from '../AccountDetail/Auto_ACCC.js';
import Auto_SubLevelAccount1 from '../AccountSubLevelGroup/Auto_SubLevelAccount';
import Auto_SubLevelAccount2 from '../AccountSubLevelGroup/Auto_SubLevelAccount';
import Auto_SubLevelAccount3 from '../AccountSubLevelGroup/Auto_SubLevelAccount';


const InsertPaymentReceivedIndex = () => {

    //#region Const
    const toaster = rsuite.useToaster();
    const BankRef = useRef();
    const CheckBankRef = useRef();
    const CheckRef = useRef();
    const FundRef = useRef();
    const ACCCRef = useRef();
    const SubLevelAccount1Ref = useRef()
    const SubLevelAccount2Ref = useRef()
    const SubLevelAccount3Ref = useRef()
    const DocSettingRef = useRef();
    let navigate = useNavigate();
    var isEdit = 0;


    const [FiscalYearId, setFiscalYearId] = useState(-1);
    const [DocState, setDocState] = useState(localStorage.getItem("PaymentDraft_Auto") != null ? localStorage.getItem("PaymentDraft_Auto") : 0);
    const [RNumber, setRNumber] = useState("");
    const [Comment, setComment] = useState("");
    const [PaymentList, setPaymentList] = useState([]);
    const [Acc_CTitle, setAcc_CTitle] = useState("");
    const [Acc_CId, setAcc_CId] = useState(General.GuidEmpty());

    const [Sub_Acc_LTitle1, setSub_Acc_LTitle1] = useState("");
    const [Sub_Acc_L1, setSub_Acc_L1] = useState(-1);
    const [Sub_Acc_Id1, setSub_Acc_Id1] = useState(General.GuidEmpty());
    const [Sub_Acc_LTitle2, setSub_Acc_LTitle2] = useState("");
    const [Sub_Acc_L2, setSub_Acc_L2] = useState(-1);
    const [Sub_Acc_Id2, setSub_Acc_Id2] = useState(General.GuidEmpty());
    const [Sub_Acc_LTitle3, setSub_Acc_LTitle3] = useState("");
    const [Sub_Acc_L3, setSub_Acc_L3] = useState(-1);
    const [Sub_Acc_Id3, setSub_Acc_Id3] = useState(General.GuidEmpty());
    const [DOCSettingId, setDOCSettingId] = useState(General.GuidEmpty());
    const [DOCSettingType, setDOCSettingType] = useState(localStorage.getItem("DOCSettingType") == null ? -1 : localStorage.getItem("DOCSettingType"));
    const [PaymentReceivedId, setPaymentReceivedId] = useState(localStorage.getItem("PaymentReceivedId") == null ? General.GuidEmpty() : localStorage.getItem("PaymentReceivedId"));
    ///  1 Fund 
    ///  2 POS
    ///  3 Kart to Kart
    ///  4 Havale
    ///  5 Personal check
    ///  6 Other check 
    ///  7 AccountTransfer
    const [TotalFundPayment, setTotalFundPayment] = useState(0);
    const [TotalHavalePayment, setTotalHavalePayment] = useState(0);
    const [TotalPersonalcheckPayment, setTotalPersonalcheckPayment] = useState(0);
    const [TotalcheckPayment, setTotalcheckPayment] = useState(0);
    const [TotalAccountTransferPayment, setTotalAccountTransferPayment] = useState(0);
    const [PayType, setPayType] = useState(4);
    // const [RemainPrice, setRemainPrice] = useState(0);
    const [TotalPayment, setTotalPayment] = useState(0);
    const [PayDate, setPayDate] = useState(moment(new Date()));

    //#endregion


    //#region Methods

    const PayDate_Change = e => {
        var m = moment(e.format()).format('jYYYY/jMM/jDD');
        setPayDate(moment(m, 'jYYYY/jMM/jDD'));
    }
    const DocSetting_Change = (id, aCCC, aCCCId, sub_Acc_L1, sub_Acc_L2, sub_Acc_L3, type, title) => {
        setDOCSettingId(id)
        setDOCSettingType(type)
        setAcc_CId(aCCCId);
        setAcc_CTitle(aCCC);
        setSub_Acc_Id1(General.GuidEmpty());
        setSub_Acc_L1(sub_Acc_L1);
        setSub_Acc_LTitle1("");
        setSub_Acc_Id2(General.GuidEmpty());
        setSub_Acc_L2(sub_Acc_L2);
        setSub_Acc_LTitle2("");
        setSub_Acc_Id3(General.GuidEmpty());
        setSub_Acc_L3(sub_Acc_L3);
        setSub_Acc_LTitle3("");
        setPaymentList([]);
        SubLevelAccount1Ref.current.Bind(General.GuidEmpty(), "", sub_Acc_L1 * 1)
        SubLevelAccount2Ref.current.Bind(General.GuidEmpty(), "", sub_Acc_L2 * 1)
        SubLevelAccount3Ref.current.Bind(General.GuidEmpty(), "", sub_Acc_L3 * 1)

    }

    const Acc_Change = (value) => {
        if (value.indexOf("|") > 1) {

            setAcc_CId(value.split("|")[0]);
            setAcc_CTitle(value.split("|")[1] + "[" + value.split("|")[2] + "]");
            setSub_Acc_L1(value.split("|")[4] * 1);
            setSub_Acc_L2(value.split("|")[5] * 1);
            setSub_Acc_L3(value.split("|")[6] * 1);
            SubLevelAccount1Ref.current.Bind(General.GuidEmpty(), "", value.split("|")[4] * 1)
            SubLevelAccount2Ref.current.Bind(General.GuidEmpty(), "", value.split("|")[5] * 1)
            SubLevelAccount3Ref.current.Bind(General.GuidEmpty(), "", value.split("|")[6] * 1)


        }
        else {
            ACCCRef.current.Bind(value, General.GuidEmpty());
            setAcc_CId(General.GuidEmpty);
            setAcc_CTitle(value);
            setSub_Acc_L1(-1);
            setSub_Acc_L2(-1);
            setSub_Acc_L3(-1);
            SubLevelAccount1Ref.current.Bind(General.GuidEmpty(), "", -1)
            SubLevelAccount2Ref.current.Bind(General.GuidEmpty(), "", -1)
            SubLevelAccount3Ref.current.Bind(General.GuidEmpty(), "", -1)
        }
    }
    const Acc_Select = (value) => {

        setAcc_CId(value.split("|")[0]);
        setAcc_CTitle(value.split("|")[1] + "[" + value.split("|")[2] + "]");
        setSub_Acc_L1(value.split("|")[4] * 1);
        setSub_Acc_L2(value.split("|")[5] * 1);
        setSub_Acc_L3(value.split("|")[6] * 1);
        SubLevelAccount1Ref.current.Bind(General.GuidEmpty(), "", value.split("|")[4] * 1)
        SubLevelAccount2Ref.current.Bind(General.GuidEmpty(), "", value.split("|")[5] * 1)
        SubLevelAccount3Ref.current.Bind(General.GuidEmpty(), "", value.split("|")[6] * 1)

    }

    const Sub1_Change = (value) => {
        if (value.indexOf("|") > 1) {
            setSub_Acc_Id1(value.split("|")[0]);
            setSub_Acc_LTitle1(value.split("|")[1]);
        }
        else {
            setSub_Acc_Id1(General.GuidEmpty());
            setSub_Acc_LTitle1(value);
            SubLevelAccount1Ref.current.Bind(-1, value, Sub_Acc_L1)
        }
    }

    const Sub1_Select = (value) => {
        setSub_Acc_Id1(value.split("|")[0]);
        setSub_Acc_LTitle1(value.split("|")[1]);
    }

    const Sub2_Change = (value) => {
        if (value.indexOf("|") > 1) {
            setSub_Acc_Id2(value.split("|")[0]);
            setSub_Acc_LTitle2(value.split("|")[1]);
        }
        else {
            setSub_Acc_Id2(General.GuidEmpty());
            setSub_Acc_LTitle2(value);
            SubLevelAccount2Ref.current.Bind(-1, value, Sub_Acc_L2)
        }
    }

    const Sub2_Select = (value) => {
        setSub_Acc_Id2(value.split("|")[0]);
        setSub_Acc_LTitle2(value.split("|")[1]);
    }


    const Sub3_Change = (value) => {
        if (value.indexOf("|") > 1) {
            setSub_Acc_Id3(value.split("|")[0]);
            setSub_Acc_LTitle3(value.split("|")[1]);
        }
        else {
            setSub_Acc_Id3(General.GuidEmpty());
            setSub_Acc_LTitle3(value);
            SubLevelAccount3Ref.current.Bind(-1, value, Sub_Acc_L3)
        }
    }

    const Sub3_Select = (value) => {
        setSub_Acc_Id3(value.split("|")[0]);
        setSub_Acc_LTitle3(value.split("|")[1]);
    }



    const GetById = () => {
        trackPromise(
            fetch(General.ApiRoute() + '/PaymentReceived/GetHeaderById', {
                method: 'post',
                headers: {
                    'ApiKey': General.APIKey(),
                    'HeaderId': localStorage.getItem("PaymentReceivedId")
                },
                credentials: 'include'
            })
                .then(res => res.json())
                .then(result => {

                    DocSettingRef.current.Bind(result.docSettingId, 2, -1, -2);
                    ACCCRef.current.Bind("", result.acccid);
                    SubLevelAccount1Ref.current.Bind(result.sub_Acc_Id1, "", result.sub_Acc_L1 * 1)
                    SubLevelAccount2Ref.current.Bind(result.sub_Acc_Id2, "", result.sub_Acc_L2 * 1)
                    SubLevelAccount3Ref.current.Bind(result.sub_Acc_Id3, "", result.sub_Acc_L3 * 1)

                    console.dir(result)
                    setDocState(result.docState);
                    setRNumber(result.number);
                    setFiscalYearId(result.fiscalYearId);
                    setDOCSettingId(result.docSettingId)
                    setDOCSettingType(result.docSettingType)
                    setComment(result.comment);
                    setPayDate(moment(result.payDate, 'jYYYY/jMM/jDD'))
                    setAcc_CId(result.acccid);


                    setTotalFundPayment(result.children.filter(x => x.payType == 1).map(o => o.price).reduce((a, b) => a + b, 0));
                    setTotalHavalePayment(result.children.filter(x => x.payType == 4).map(o => o.price * 1).reduce((a, b) => a + b, 0));
                    setTotalPersonalcheckPayment(result.children.filter(x => x.payType == 5).map(o => o.price).reduce((a, b) => a + b, 0));
                    setTotalcheckPayment(result.children.filter(x => x.payType == 6).map(o => o.price).reduce((a, b) => a + b, 0));
                    setTotalAccountTransferPayment(result.children.filter(x => x.payType == 7).map(o => o.price).reduce((a, b) => a + b, 0));
                    setTotalPayment(result.children.map(o => o.price).reduce((a, b) => a + b, 0));


                    var temp = [];
                    for (let index = 0; index < result.children.length; index++) {
                        if (index == 0) {
                            setPayType(result.children[index].payType);
                        }
                        temp.push(
                            {
                                row: index + 1,
                                Id: result.children[index].id,
                                Editable: true,
                                status: "",
                                Price: result.children[index].price,
                                PayType: result.children[index].payType,
                                PayDate: result.children[index].payDate,
                                PayTime: result.children[index].payTime,
                                RecieptNo: result.children[index].recieptNo,
                                AccountTransfer: result.children[index].accountTransfer,
                                AccountTransferId: result.children[index].accountTransferId,
                                DestinationAccountNo: result.children[index].destinationAccountNo,
                                RecieptItemId: result.children[index].recieptItemid,
                                ByCheck: result.children[index].payType == 6 ? result.children[index].recieptItem_ByCheck :
                                    result.children[index].payType == 5 ? result.children[index].byCheck : "",
                                CheckBookPageId: result.children[index].checkBookPageId,
                                CheckNo: result.children[index].payType == 6 ? result.children[index].recieptItem_CheckNo :
                                    result.children[index].payType == 5 ? result.children[index].checkNo : "",
                                CheckDate: result.children[index].payType == 6 ? result.children[index].recieptItem_CheckDate :
                                    result.children[index].payType == 5 ? result.children[index].checkDate : "",
                                Branch: result.children[index].recieptItem_Branch,
                                Bank: result.children[index].recieptItem_Bank,
                                Comment: result.children[index].comment,
                                BankAccountId: result.children[index].bankAccountId,
                                BankAccount: result.children[index].bankAccount,
                                FundId: result.children[index].fundId,
                                Fund: result.children[index].fund,
                                ConfirmCheck: result.children[index].confirmCheck,
                            });
                    }

                    setTimeout(() => {

                        setAcc_CTitle(result.acc_CTitle);

                        setSub_Acc_Id1(result.sub_Acc_Id1);
                        setSub_Acc_L1(result.sub_Acc_L1);
                        setSub_Acc_LTitle1(result.sub_Acc_LTitle1);

                        setSub_Acc_Id2(result.sub_Acc_Id2);
                        setSub_Acc_L2(result.sub_Acc_L2);
                        setSub_Acc_LTitle2(result.sub_Acc_LTitle2);

                        setSub_Acc_Id3(result.sub_Acc_Id3);
                        setSub_Acc_L3(result.sub_Acc_L3);
                        setSub_Acc_LTitle3(result.sub_Acc_LTitle3);
                        setPaymentList(temp)

                    }, 500)


                })
        )
    }



    const SaveItem = (row) => {
        // setEdited(true);
        var temp = [...PaymentList];
        console.dir(temp)
        console.dir(row)
        var index = temp.findIndex(x => x.row == row);
        console.dir(index)
        if (index != -1) {

            if (temp[index].Price == "0" && temp[index].Price == 0) {
                toaster.push(General.ShowMessage('error', General.ErrorMessage("مبلغ اجباری می باشد")), 'topCenter')
                return;
            }
            else if (temp[index].BankAccountId == General.GuidEmpty() && (PayType == 4 || PayType == 5)) {
                toaster.push(General.ShowMessage('error', General.ErrorMessage("انتخاب حساب بانکی اجباری می باشد")), 'topCenter')
                return;
            }
            else if (temp[index].FundId == General.GuidEmpty() && PayType == 1) {
                toaster.push(General.ShowMessage('error', General.ErrorMessage("انتخاب صندوق اجباری می باشد")), 'topCenter')
                return;
            }
            else if (temp[index].RecieptItemId == General.GuidEmpty() && PayType == 6) {
                toaster.push(General.ShowMessage('error', General.ErrorMessage("انتخاب چک دریافتی اجباری می باشد")), 'topCenter')
                return;
            }
            else if (temp[index].CheckBookPageId == General.GuidEmpty() && PayType == 5) {
                toaster.push(General.ShowMessage('error', General.ErrorMessage("انتخاب چک اجباری می باشد")), 'topCenter')
                return;
            }
            else if (temp[index].AccountTransferId == General.GuidEmpty() && PayType == 7) {
                toaster.push(General.ShowMessage('error', General.ErrorMessage("انتخاب فرد اجباری می باشد")), 'topCenter')
                return;
            }


            else {
                temp[index].status = "";
                temp[index].Price = temp[index].Price != "0" && temp[index].Price != 0 ? temp[index].Price.replaceAll(',', '') * 1 : 0;
                temp[index].PayTime = temp[index].PayTime.getHours() + ":" + temp[index].PayTime.getMinutes();
                temp[index].CheckDate = PayType == 5 ? moment(temp[index].CheckDate.format()).format('jYYYY/jMM/jDD') : "";
                temp[index].PayDate = moment(temp[index].PayDate.format()).format('jYYYY/jMM/jDD');
                console.dir(temp)
                console.dir(temp.filter(item => item.FundId == General.GuidEmpty()).length == 0)
                if ((PayType == 7 && temp.filter(item => item.AccountTransferId == General.GuidEmpty() && item.PayType == 7).length == 0) ||
                    (PayType == 1 && temp.filter(item => item.FundId == General.GuidEmpty() && item.PayType == 1).length == 0) ||
                    (PayType == 4 && temp.filter(item => item.BankAccountId == General.GuidEmpty() && item.PayType == 4).length == 0) ||
                    (PayType == 5 && temp.filter(item => item.BankAccountId == General.GuidEmpty() && item.CheckBookPageId == General.GuidEmpty() && item.PayType == 5).length == 0) ||
                    (PayType == 6 && temp.filter(item => item.RecieptItemId == General.GuidEmpty() && item.PayType == 6).length == 0) ||
                    (PayType == 7 && temp.filter(item => item.AccountTransferId == General.GuidEmpty() && item.PayType == 7).length == 0))
                    NewItem(PayType)

            }


            setTotalFundPayment(temp.filter(x => x.PayType == 1).map(o => o.Price).reduce((a, b) => a + b, 0));
            setTotalHavalePayment(temp.filter(x => x.PayType == 4).map(o => o.Price).reduce((a, b) => a + b, 0));
            setTotalPersonalcheckPayment(temp.filter(x => x.PayType == 5).map(o => o.Price).reduce((a, b) => a + b, 0));
            setTotalcheckPayment(temp.filter(x => x.PayType == 6).map(o => o.Price).reduce((a, b) => a + b, 0));
            setTotalAccountTransferPayment(temp.filter(x => x.PayType == 7).map(o => o.Price).reduce((a, b) => a + b, 0));
            setTotalPayment(temp.map(o => o.Price).reduce((a, b) => a + b, 0));

        }


    }

    const DeleteItem = (row) => {

        var temp = [...PaymentList.filter(item => item.row !== row)];
        setPaymentList(temp);
        setTotalFundPayment(temp.filter(x => x.PayType == 1).map(o => o.Price).reduce((a, b) => a + b, 0));
        setTotalHavalePayment(temp.filter(x => x.PayType == 4).map(o => o.Price * 1).reduce((a, b) => a + b, 0));
        setTotalPersonalcheckPayment(temp.filter(x => x.PayType == 5).map(o => o.Price).reduce((a, b) => a + b, 0));
        setTotalcheckPayment(temp.filter(x => x.PayType == 6).map(o => o.Price).reduce((a, b) => a + b, 0));
        setTotalAccountTransferPayment(temp.filter(x => x.PayType == 7).map(o => o.Price).reduce((a, b) => a + b, 0));
        setTotalPayment(temp.map(o => o.Price).reduce((a, b) => a + b, 0));
        const inputElement = document.querySelector('.FocusBtn');
        if (inputElement) {
            inputElement.focus();
        }


    }

    const Save = () => {

        if (PayDate == "" || PayDate == null) {
            toaster.push(General.ShowMessage('error', General.ErrorMessage(" وارد کردن تاریخ پرداخت اجباری می باشد")), 'topCenter')
            return;
        }

        else if (DOCSettingId == General.GuidEmpty()) {
            toaster.push(General.ShowMessage('error', General.ErrorMessage(" وارد کردن نوع پرداخت اجباری می باشد")), 'topCenter')
            return;
        }
        else if (Acc_CId == General.GuidEmpty()) {
            toaster.push(General.ShowMessage('error', General.ErrorMessage(" انتخاب کردن حساب معین اجباری می باشد")), 'topCenter')
            return;
        }

        else if (Sub_Acc_Id1 == General.GuidEmpty() && Sub_Acc_L1 != -1) {
            toaster.push(General.ShowMessage('error', General.ErrorMessage(" انتخاب کردن حساب تفصیلی سطح 1 اجباری می باشد")), 'topCenter')
            return;
        }
        else if (Sub_Acc_Id2 == General.GuidEmpty() && Sub_Acc_L2 != -1) {
            toaster.push(General.ShowMessage('error', General.ErrorMessage(" انتخاب کردن حساب تفصیلی سطح 2 اجباری می باشد")), 'topCenter')
            return;
        }
        else if (Sub_Acc_Id3 == General.GuidEmpty() && Sub_Acc_L3 != -1) {
            toaster.push(General.ShowMessage('error', General.ErrorMessage(" انتخاب کردن حساب تفصیلی سطح 3 اجباری می باشد")), 'topCenter')
            return;
        }
        else {
            var children = [...PaymentList.filter(item => item.Price !== "0" && item.Price != 0)];
            var RequestOptions = {
                data: {
                    "PayDate": moment(PayDate.format()).format('jYYYY/jMM/jDD'),
                    "Id": PaymentReceivedId == null ? General.GuidEmpty() : PaymentReceivedId,
                    "Acc_CId": Acc_CId,
                    "DOCSettingId": DOCSettingId,
                    "Acc_CTitle": Acc_CTitle,
                    "Sub_Acc_Id1": Sub_Acc_Id1,
                    "Sub_Acc_Id2": Sub_Acc_Id2,
                    "Sub_Acc_Id3": Sub_Acc_Id3,
                    "Sub_Acc_L1": Sub_Acc_L1,
                    "Sub_Acc_L2": Sub_Acc_L2,
                    "Sub_Acc_L3": Sub_Acc_L3,
                    "Comment": Comment,
                    "FiscalYearId": FiscalYearId,
                    "Children": children
                },
                url: General.ApiRoute() + "/PaymentReceived/Save",
                method: "post",
                withCredentials: true,

                headers: {
                    'ApiKey': General.APIKey(),
                    'Content-Type': 'application/json'
                }
            }

            trackPromise(
                axios(RequestOptions)
                    .then(function (result) {

                        if (result.data.includes("OK")) {
                            toaster.push(General.ShowMessage('success', General.SuccessMessage("ذخیزه شده است")), 'topCenter')
                            // BindPayment(HeaderPrice, headerId);
                        }
                        else {
                            toaster.push(General.ShowMessage('error', General.ErrorMessage(result.data)), 'topCenter')

                        }

                    }).catch((error) => {
                        console.dir(error)
                        toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                    })
            )

        }
    }

    const onEditItem = (row) => {
        const updatedPaymentList = [...PaymentList];
        var Deleteindex = updatedPaymentList.findIndex(x => x.status == "EDIT" && x.PayType == PayType);
        var index = updatedPaymentList.findIndex(x => x.row == row);

        if (index != -1) {
            isEdit = 1;
            if (Deleteindex != -1) {
                if (updatedPaymentList[Deleteindex].Price == 0) {
                    updatedPaymentList.splice(Deleteindex, 1);

                }
                else {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage("ابتدا ردیفی که در حالت ویرایش می باشد را ذخیره کنید.")), 'topCenter')
                    return;
                }
                // updatedPaymentList[Deleteindex].status = "";
            }
            updatedPaymentList[index].status = "EDIT";
            updatedPaymentList[index].Price = PN.sliceNumber(updatedPaymentList[index].Price);
            updatedPaymentList[index].PayDate = moment(updatedPaymentList[index].PayDate, 'jYYYY/jMM/jDD');
            updatedPaymentList[index].PayTime = convertHHMMToDate(updatedPaymentList[index].PayTime);
            updatedPaymentList[index].CheckDate = updatedPaymentList[index].CheckDate != "" && updatedPaymentList[index].CheckDate != null && PayType == 5 ? moment(updatedPaymentList[index].CheckDate, 'jYYYY/jMM/jDD') : "";
            setPaymentList(updatedPaymentList);

            setTimeout(() => {
                console.dir(PaymentList)

                if (PayType == 1) {
                    FundRef.current.Bind(updatedPaymentList[index].FundId);
                }

                if (PayType == 4) {
                    BankRef.current.Bind(updatedPaymentList[index].BankAccountId);
                }
                if (PayType == 5) {
                    CheckBankRef.current.Bind(updatedPaymentList[index].BankAccountId);
                    CheckRef.current.Bind(updatedPaymentList[index].BankAccountId, updatedPaymentList[index].CheckBookPageId);

                }
                if (PayType == 6) {
                    CheckRef.current.Bind(General.GuidEmpty());
                }
                if (PayType == 7) {
                    useRef.current.Bind(General.GuidEmpty());
                }

            }, 500)

        }

    }

    const NewItem = (payType) => {

        if (DOCSettingId == General.GuidEmpty()) {
            toaster.push(General.ShowMessage('error', General.ErrorMessage("ابتدا نوع عملیات رسید پرداخت را مشخص کنید.")), 'topCenter')
            return;
        }
        else {
            var temp = [...PaymentList];
            var index = temp.findIndex(x => x.status == "EDIT" && x.PayType == payType);
            if (index == -1) {
                temp.push(
                    {
                        row: temp.length + 1,
                        Id: General.GuidEmpty(),
                        Editable: true,
                        status: "EDIT",
                        Price: 0,
                        PayType: payType,
                        PayDate: moment(new Date()),
                        PayTime: new Date(),
                        RecieptNo: "",
                        AccountTransfer: "",
                        AccountTransferId: General.GuidEmpty(),
                        DestinationAccountNo: "",
                        RecieptItemId: General.GuidEmpty(),
                        ByCheck: "",
                        CheckBookPageId: General.GuidEmpty(),
                        CheckNo: "",
                        CheckDate: moment(new Date()),
                        Branch: "",
                        Bank: "",
                        Comment: "",
                        BankAccountId: General.GuidEmpty(),
                        BankAccount: "",
                        FundId: General.GuidEmpty(),
                        Fund: "",
                        ConfirmCheck: 0,
                    });
                setPaymentList(temp)
            }
            setTimeout(() => {
                if (payType == 1) {
                    FundRef.current.Bind(General.GuidEmpty());
                }

                if (payType == 4) {
                    BankRef.current.Bind(General.GuidEmpty());
                }
                if (payType == 5) {
                    CheckBankRef.current.Bind(General.GuidEmpty());
                }
                if (payType == 6) {
                    CheckRef.current.Bind(General.GuidEmpty());
                }
                if (payType == 7) {
                    useRef.current.Bind(General.GuidEmpty());
                }

            }, 500)
        }
    }

    const convertHHMMToDate = (time) => {
        const [hours, minutes] = time.split(':').map(Number);
        const date = new Date();
        date.setHours(hours, minutes, 0, 0);
        return date;
    };

    const Change_Item = (row, dataType, value, text) => {


        var temp = [...PaymentList];
        var index = temp.findIndex(x => x.row == row);
        if (index != -1) {
            if (dataType == "Price") {
                var price = value != "0" && value != 0 ? value.replaceAll(',', '') : 0;
                temp[index].Price = PN.sliceNumber(price);

            }
            else if (dataType == "Fund") {
                temp[index].FundId = value;
                temp[index].Fund = text;
            }
            else if (dataType == "CheckBookPage") {
                console.dir(value);
                console.dir(text);
                temp[index].CheckBookPageId = value;
                temp[index].CheckNo = text;
            }
            else if (dataType == "ByCheck") {
                temp[index].ByCheck = value;
            }
            else if (dataType == "ConfirmCheck") {
                temp[index].ConfirmCheck = value * 1;
            }
            else if (dataType == "RecieptItem") {
                temp[index].RecieptItemId = value;
                temp[index].CheckNo = text.split("|")[0];
                temp[index].Branch = text.split("|")[1];
                temp[index].Bank = text.split("|")[2];
                temp[index].Price = text.split("|")[3];
                temp[index].ByCheck = text.split("|")[4];
            }

            else if (dataType == "RecieptNo") {
                temp[index].RecieptNo = value;
            }

            else if (dataType == "Branch") {
                temp[index].Branch = value;
            }
            else if (dataType == "Comment") {
                temp[index].Comment = value;
            }
            else if (dataType == "ByCheck") {
                temp[index].ByCheck = value;
            }
            else if (dataType == "BankAccount") {
                temp[index].BankAccountId = value;
                temp[index].BankAccount = text;
                if (PayType == 5)
                    CheckRef.current.Bind(value);
            }
            else if (dataType == "DestinationAccountNo") {
                temp[index].DestinationAccountNo = value;
            }
            else if (dataType == "Fund") {
                temp[index].FundId = value;
                temp[index].Fund = text;
            }
            else if (dataType == "ConfirmCheck") {
                temp[index].ConfirmCheck = value;
            }

            else if (dataType == "PayTime") {
                temp[index].PayTime = value;
            }
            else if (dataType == "CheckDate") {
                var m = moment(value.format()).format('jYYYY/jMM/jDD');
                temp[index].CheckDate = moment(m, 'jYYYY/jMM/jDD');
            }
            else if (dataType == "PayDate") {
                var m = moment(value.format()).format('jYYYY/jMM/jDD');
                temp[index].PayDate = moment(m, 'jYYYY/jMM/jDD');
            }

            if (!isEdit)
                setPaymentList(temp);
            else
                isEdit = 0;
        }
    }


    const CheckPermission = () => {
        var myHeaders = new Headers();
        myHeaders.append("ApiKey", General.APIKey());
        myHeaders.append("Page", 40);
        myHeaders.append("Operation", 1);

        var requestOptions = {
            method: "Get",
            headers: myHeaders,
            credentials: 'include'

        };
        trackPromise(
            fetch(General.ApiRoute() + "/Common/CheckPermission", requestOptions)
                .then(response => response.text())
                .then(result => {
                    if (result.toString() != "OK") {
                        navigate("/AccessDenied");
                    }
                    else {
                        if (localStorage.getItem("PaymentReceivedId") != undefined && localStorage.getItem("PaymentReceivedId") != General.GuidEmpty()) {
                            GetById(localStorage.getItem("PaymentReceivedId"));
                        }
                        else {
                            DocSettingRef.current.Bind(General.GuidEmpty(), 2, -1, -2);
                            ACCCRef.current.Bind("", General.GuidEmpty());
                        }
                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')
                })
        )
    }

    const handelKeyDown = (e) => {
        // console.dir(e.key)

        if (e.key == "Enter") {

            if ([...PaymentList].length > 0) {
                var index = [...PaymentList].findIndex(x => x.status == "EDIT" && x.PayType * 1 == PayType * 1);
                console.dir(index)
                console.dir(PayType)
                console.dir(PaymentList)
                if (index != -1) {
                    SaveItem([...PaymentList][index].row);
                    return;
                }
                else if (DOCSettingId != General.GuidEmpty()) {
                    NewItem(PayType);
                    return;
                }
            }
            else if (DOCSettingId != General.GuidEmpty()) {
                NewItem(PayType);
            }
        }
        if (e.key == "Delete") {
            var index = [...PaymentList].findIndex(x => x.status == "EDIT");
            if (index != -1)
                DeleteItem([...PaymentList][index].row);
            else if ([...PaymentList].length > 0) {
                var LastPay = [...PaymentList].filter(x => x.PayType == PayType).length;
                if (LastPay != 0)
                    DeleteItem([...PaymentList][LastPay - 1].row);
            }
        }


        if (e.key == "Escape") {
            navigate("/PaymentReceived")
        }


        if (e.shiftKey && e.code === 'KeyP') {
            // localStorage.setItem("BackPage", "PaymentReceived");
            // navigate("/PrintPaymentReceived")
            window.open("/PrintPaymentReceived", "_blank");

        }

    }


    useEffect(() => {
        CheckPermission();
        document.title = " رسید پرداخت ";
        const inputElement = document.querySelector('.FocusComment');
        console.dir(inputElement)
        if (inputElement) {
            inputElement.focus();
        }
    }, [])
    //#endregion



    return (

        <Layout title="رسید پرداخت">
            <div className="h-100 p-1" onKeyDown={handelKeyDown} >
                <rsuite.Panel className="bg-white ">
                    <rsuite.Grid fluid>
                        <rsuite.Row>

                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className="text-left" >
                                <rsuite.Button appearance="primary" size="xs" className={PaymentReceivedId != General.GuidEmpty() ? "m-1" : "hide"} onClick={() =>window.open("/PrintPaymentReceived", "_blank")}> پرینت</rsuite.Button>
                                <rsuite.Button appearance="primary" size="xs" className="m-1" onClick={() => Save(DocState)}>{DocState == 1 ? <> ثبت و صدور سند حسابداری </> : <>ثبت</>}</rsuite.Button>
                                <rsuite.Button appearance="primary" color="yellow" size="xs" className="m-1" onClick={() => (navigate("/PaymentReceived"))}>  بازگشت</rsuite.Button>

                            </rsuite.Col>
                        </rsuite.Row>
                    </rsuite.Grid>
                    <hr />
                    <rsuite.Row className='p-1'>


                        <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={24}>
                            <label>شماره رسید : </label>
                            <rsuite.Input disabled value={RNumber} onChange={(e) => setRNumber(e)} />

                        </rsuite.Col>
                        <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={24}>
                            <label> تاریخ </label>
                            <DatePicker className="rs-input " isGregorian={false} timePicker={false} icon={BiIcon.BiCalendar} value={PayDate} onChange={PayDate_Change} />
                        </rsuite.Col>
                        <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={24}>
                            <label>  توضیحات</label>
                            <rsuite.Input className='FocusComment' value={Comment} onChange={(e) => (setComment(e))} />
                        </rsuite.Col>
                        <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={24}>
                            <label> نوع عملیات</label>
                            <Drp_DocSetting value={DOCSettingId}
                                onChange={(Id, ACCC, ACCCId, Sub_Acc_L1, Sub_Acc_L2, Sub_Acc_L3, Type, Title) =>
                                    DocSetting_Change(Id, ACCC, ACCCId, Sub_Acc_L1, Sub_Acc_L2, Sub_Acc_L3, Type, Title)}
                                ref={DocSettingRef} />
                        </rsuite.Col>



                    </rsuite.Row>
                    <rsuite.Row>
                        <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={24}>
                            <BiIcon.BiSolidStar className={Acc_CId == General.GuidEmpty() ? 'text-danger' : 'hide'} />
                            <label> حساب معین </label>
                            <Auto_ACCC value={Acc_CTitle} onChange={Acc_Change} onSelect={Acc_Select} ref={ACCCRef} />
                        </rsuite.Col>
                        <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={24}>
                            <BiIcon.BiSolidStar className={Sub_Acc_Id1 == General.GuidEmpty() && Sub_Acc_L1 != -1 ? 'text-danger' : 'hide'} />  <label> تفصیلی 1 </label>
                            <Auto_SubLevelAccount1 className="rs-input" value={Sub_Acc_LTitle1}
                                onChange={value => Sub1_Change(value)}
                                onSelect={value => Sub1_Select(value)}
                                ref={SubLevelAccount1Ref} />
                        </rsuite.Col>
                        <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={24}>
                            <BiIcon.BiSolidStar className={Sub_Acc_Id2 == General.GuidEmpty() && Sub_Acc_L2 != -1 ? 'text-danger' : 'hide'} />  <label> تفصیلی 2 </label>
                            <Auto_SubLevelAccount2 className="rs-input" value={Sub_Acc_LTitle2}
                                onChange={value => Sub2_Change(value)}
                                onSelect={value => Sub2_Select(value)}
                                ref={SubLevelAccount2Ref} />
                        </rsuite.Col>
                        <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={24}>
                            <BiIcon.BiSolidStar className={Sub_Acc_Id3 == General.GuidEmpty() && Sub_Acc_L3 != -1 ? 'text-danger' : 'hide'} />  <label> تفصیلی 3 </label>
                            <Auto_SubLevelAccount3 className="rs-input" value={Sub_Acc_LTitle3}
                                onChange={value => Sub3_Change(value)}
                                onSelect={value => Sub3_Select(value)}
                                ref={SubLevelAccount3Ref} />
                        </rsuite.Col>
                    </rsuite.Row>
                    <hr />

                    <rsuite.Row className="p-1 mb-5 pb-5" >
                        <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                            <rsuite.Button className='FocusBtn' disabled={DOCSettingId == General.GuidEmpty() ? true : false} appearance="primary"
                                color="green" size='xs'
                                onClick={() => NewItem(PayType)}>
                                اضافه شدن پرداخت جدید
                            </rsuite.Button>
                        </rsuite.Col>

                        <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className='mt-3'>
                            <rsuite.Tabs defaultActiveKey={PayType.toString()} onSelect={(eventKey) => (setPayType(eventKey * 1), NewItem(eventKey))} vertical appearance="subtle">
                                {(DOCSettingType != 6 && DOCSettingType != 5) && (
                                    <rsuite.Tabs.Tab eventKey="4" title="حواله بانکی">
                                        <rsuite.Table height={PaymentList.filter(o => o.PayType == 4).length < 3 ? 160 : PaymentList.filter(o => o.PayType == 4).length >= 3 && PaymentList.filter(o => o.PayType == 4).length < 6 ? PaymentList.filter(o => o.PayType == 4).length * 70 : 320}
                                            data={PaymentList.filter(o => o.PayType == 4)} wordWrap>

                                            <rsuite.Table.Column flexGrow={1} fullText resizable>
                                                <rsuite.Table.HeaderCell>تاریخ ثبت </rsuite.Table.HeaderCell>
                                                <rsuite.Table.Cell >

                                                    {(rowData, rowIndex) => {
                                                        return <>
                                                            {rowData.status == 'EDIT' ? (
                                                                <DatePicker className="rs-input " isGregorian={false}
                                                                    timePicker={false} icon={BiIcon.BiCalendar} value={rowData.PayDate} onChange={value => {
                                                                        Change_Item?.(rowData.row, "PayDate", value, "");
                                                                    }} />
                                                            ) : (
                                                                <text>
                                                                    {rowData.PayDate}
                                                                </text>
                                                            )}
                                                        </>
                                                    }}

                                                </rsuite.Table.Cell>



                                            </rsuite.Table.Column>
                                            <rsuite.Table.Column flexGrow={1} fullText resizable>
                                                <rsuite.Table.HeaderCell>ساعت ثبت </rsuite.Table.HeaderCell>
                                                <rsuite.Table.Cell >

                                                    {(rowData, rowIndex) => {
                                                        return <>

                                                            {rowData.status == 'EDIT' ? (



                                                                <rsuite.TimePicker block onChange={value => {
                                                                    Change_Item?.(rowData.row, "PayTime", value, "");
                                                                }} value={rowData.PayTime} />

                                                            ) : (
                                                                <text>
                                                                    {rowData.PayTime}
                                                                </text>
                                                            )}
                                                        </>
                                                    }}

                                                </rsuite.Table.Cell>


                                            </rsuite.Table.Column>
                                            <rsuite.Table.Column flexGrow={2} fullText resizable>
                                                <rsuite.Table.HeaderCell>شماره حساب </rsuite.Table.HeaderCell>
                                                <rsuite.Table.Cell >

                                                    {(rowData, rowIndex) => {
                                                        return <>

                                                            {rowData.status == 'EDIT' ? (


                                                                <Drp_Bank value={rowData.BankAccountId} onChange={(value, text) => {
                                                                    Change_Item?.(rowData.row, "BankAccount", value, text);
                                                                }} ref={BankRef} />


                                                            ) : (
                                                                <text>
                                                                    {rowData.BankAccount}
                                                                </text>
                                                            )}
                                                        </>
                                                    }}

                                                </rsuite.Table.Cell>



                                            </rsuite.Table.Column>
                                            <rsuite.Table.Column flexGrow={2} >
                                                <rsuite.Table.HeaderCell>شماره رسید</rsuite.Table.HeaderCell>
                                                <rsuite.Table.Cell >
                                                    {(rowData) => {
                                                        return <>
                                                            {rowData.status == 'EDIT' ? (
                                                                <>
                                                                    <rsuite.Input value={rowData.RecieptNo} onChange={value => {
                                                                        Change_Item?.(rowData.row, "RecieptNo", value, "");
                                                                    }}

                                                                    />
                                                                </>

                                                            ) : (
                                                                <text>
                                                                    {rowData.RecieptNo}
                                                                </text>
                                                            )}
                                                        </>
                                                    }}
                                                </rsuite.Table.Cell>
                                            </rsuite.Table.Column>
                                            <rsuite.Table.Column flexGrow={2} >
                                                <rsuite.Table.HeaderCell>شماره حساب مقصد</rsuite.Table.HeaderCell>
                                                <rsuite.Table.Cell >
                                                    {(rowData) => {
                                                        return <>
                                                            {rowData.status == 'EDIT' ? (
                                                                <>
                                                                    <rsuite.Input value={rowData.DestinationAccountNo} onChange={value => {
                                                                        Change_Item?.(rowData.row, "DestinationAccountNo", value, "");
                                                                    }}

                                                                    />
                                                                </>

                                                            ) : (
                                                                <text>
                                                                    {rowData.DestinationAccountNo}
                                                                </text>
                                                            )}
                                                        </>
                                                    }}
                                                </rsuite.Table.Cell>
                                            </rsuite.Table.Column>


                                            <rsuite.Table.Column flexGrow={2} >
                                                <rsuite.Table.HeaderCell>مبلغ  (ریال)</rsuite.Table.HeaderCell>
                                                <rsuite.Table.Cell >
                                                    {(rowData) => {
                                                        return <>
                                                            {rowData.status == 'EDIT' ? (
                                                                <rsuite.Input value={rowData.Price} onChange={value => {
                                                                    Change_Item?.(rowData.row, "Price", value, "");
                                                                }}

                                                                />

                                                            ) : (
                                                                <text>
                                                                    {PN.sliceNumber(rowData.Price)}
                                                                    <rsuite.Text className='Font10 float-start' as='sub'>{rowData.Price != "0" ? <>{PN.convert(rowData.Price)} ریال</> : ""}</rsuite.Text>

                                                                </text>
                                                            )}
                                                        </>
                                                    }}
                                                </rsuite.Table.Cell>
                                            </rsuite.Table.Column>

                                            <rsuite.Table.Column flexGrow={3} >
                                                <rsuite.Table.HeaderCell>توضیحات</rsuite.Table.HeaderCell>
                                                <rsuite.Table.Cell >
                                                    {(rowData) => {
                                                        return <>
                                                            {rowData.status == 'EDIT' ? (
                                                                <>
                                                                    <rsuite.Input value={rowData.Comment} onChange={value => {
                                                                        Change_Item?.(rowData.row, "Comment", value, "");
                                                                    }}

                                                                    />
                                                                </>

                                                            ) : (
                                                                <text>
                                                                    {rowData.Comment}
                                                                </text>
                                                            )}
                                                        </>
                                                    }}
                                                </rsuite.Table.Cell>
                                            </rsuite.Table.Column>

                                            <rsuite.Table.Column width={100} fixed='right'>
                                                <rsuite.Table.HeaderCell></rsuite.Table.HeaderCell>
                                                <rsuite.Table.Cell>
                                                    {(rowData) => {
                                                        return <>


                                                            {rowData.status != "EDIT" ? <BiIcon.BiEditAlt onClick={() => onEditItem(rowData.row)} className='fs-6 Cursor' />
                                                                :
                                                                <BiIcon.BiSave onClick={() => SaveItem(rowData.row)} className='fs-6 text-success Cursor' />
                                                            }
                                                            &nbsp;&nbsp;&nbsp;
                                                            <BiIcon.BiTrash onClick={() => DeleteItem(rowData.row)} className='fs-6 text-danger Cursor' />
                                                        </>
                                                    }}
                                                </rsuite.Table.Cell>
                                            </rsuite.Table.Column>
                                        </rsuite.Table>
                                        <rsuite.Row>
                                            <rsuite.Col xs={24} className='fw-bold text-start'>
                                                {PaymentList.filter(o => o.PayType == 4 && o.status == "EDIT").length > 0 && PaymentList.filter(o => o.PayType == 4 && o.status == "EDIT")[0].Price != "0" ? <>{PN.convert(PaymentList.filter(o => o.PayType == 4 && o.status == "EDIT")[0].Price.replaceAll(',', ''))} ریال</> : ""}

                                            </rsuite.Col>
                                        </rsuite.Row>
                                    </rsuite.Tabs.Tab>)}


                                {(DOCSettingType != 0) && (
                                    <rsuite.Tabs.Tab eventKey="1" title="صندوق">
                                        <rsuite.Table height={PaymentList.filter(o => o.PayType == 1).length < 3 ? 160 : PaymentList.filter(o => o.PayType == 1).length >= 3 && PaymentList.filter(o => o.PayType == 1).length < 6 ? PaymentList.filter(o => o.PayType == 1).length * 70 : 320}
                                            data={PaymentList.filter(o => o.PayType == 1)} wordWrap>

                                            <rsuite.Table.Column flexGrow={1} fullText resizable>
                                                <rsuite.Table.HeaderCell>تاریخ ثبت </rsuite.Table.HeaderCell>
                                                <rsuite.Table.Cell >

                                                    {(rowData, rowIndex) => {
                                                        return <>
                                                            {rowData.status == 'EDIT' ? (
                                                                <DatePicker className="rs-input " isGregorian={false}
                                                                    timePicker={false} icon={BiIcon.BiCalendar} value={rowData.PayDate} onChange={value => {
                                                                        Change_Item?.(rowData.row, "PayDate", value, "");
                                                                    }} />
                                                            ) : (
                                                                <text>
                                                                    {rowData.PayDate}
                                                                </text>
                                                            )}
                                                        </>
                                                    }}

                                                </rsuite.Table.Cell>



                                            </rsuite.Table.Column>
                                            <rsuite.Table.Column flexGrow={1} fullText resizable>
                                                <rsuite.Table.HeaderCell>ساعت ثبت </rsuite.Table.HeaderCell>
                                                <rsuite.Table.Cell >

                                                    {(rowData, rowIndex) => {
                                                        return <>

                                                            {rowData.status == 'EDIT' ? (



                                                                <rsuite.TimePicker block onChange={value => {
                                                                    Change_Item?.(rowData.row, "PayTime", value, "");
                                                                }} value={rowData.PayTime} />

                                                            ) : (
                                                                <text>
                                                                    {rowData.PayTime}
                                                                </text>
                                                            )}
                                                        </>
                                                    }}

                                                </rsuite.Table.Cell>


                                            </rsuite.Table.Column>
                                            <rsuite.Table.Column flexGrow={2} fullText resizable>
                                                <rsuite.Table.HeaderCell> صندوق </rsuite.Table.HeaderCell>
                                                <rsuite.Table.Cell >

                                                    {(rowData, rowIndex) => {
                                                        return <>

                                                            {rowData.status == 'EDIT' ? (


                                                                <Drp_Fund value={rowData.FundId} onChange={(value, text) => {
                                                                    Change_Item?.(rowData.row, "Fund", value, text);
                                                                }} ref={FundRef} />


                                                            ) : (
                                                                <text>
                                                                    {rowData.Fund}
                                                                </text>
                                                            )}
                                                        </>
                                                    }}

                                                </rsuite.Table.Cell>



                                            </rsuite.Table.Column>


                                            <rsuite.Table.Column flexGrow={2} >
                                                <rsuite.Table.HeaderCell>مبلغ  (ریال)</rsuite.Table.HeaderCell>
                                                <rsuite.Table.Cell >
                                                    {(rowData) => {
                                                        return <>
                                                            {rowData.status == 'EDIT' ? (
                                                                <rsuite.Input value={rowData.Price} onChange={value => {
                                                                    Change_Item?.(rowData.row, "Price", value, "");
                                                                }}

                                                                />

                                                            ) : (
                                                                <text>
                                                                    {PN.sliceNumber(rowData.Price)}
                                                                    <rsuite.Text className='Font10 float-start' as='sub'>{rowData.Price != "0" ? <>{PN.convert(rowData.Price)} ریال</> : ""}</rsuite.Text>

                                                                </text>
                                                            )}
                                                        </>
                                                    }}
                                                </rsuite.Table.Cell>
                                            </rsuite.Table.Column>

                                            <rsuite.Table.Column flexGrow={3} >
                                                <rsuite.Table.HeaderCell>توضیحات</rsuite.Table.HeaderCell>
                                                <rsuite.Table.Cell >
                                                    {(rowData) => {
                                                        return <>
                                                            {rowData.status == 'EDIT' ? (
                                                                <>
                                                                    <rsuite.Input value={rowData.Comment} onChange={value => {
                                                                        Change_Item?.(rowData.row, "Comment", value, "");
                                                                    }}

                                                                    />
                                                                </>

                                                            ) : (
                                                                <text>
                                                                    {rowData.Comment}
                                                                </text>
                                                            )}
                                                        </>
                                                    }}
                                                </rsuite.Table.Cell>
                                            </rsuite.Table.Column>

                                            <rsuite.Table.Column width={100} fixed='right'>
                                                <rsuite.Table.HeaderCell></rsuite.Table.HeaderCell>
                                                <rsuite.Table.Cell>
                                                    {(rowData) => {
                                                        return <>


                                                            {rowData.status != "EDIT" ? <BiIcon.BiEditAlt onClick={() => onEditItem(rowData.row)} className='fs-6 Cursor' />
                                                                :
                                                                <BiIcon.BiSave onClick={() => SaveItem(rowData.row)} className='fs-6 text-success Cursor' />
                                                            }
                                                            &nbsp;&nbsp;&nbsp;
                                                            <BiIcon.BiTrash onClick={() => DeleteItem(rowData.row)} className='fs-6 text-danger Cursor' />
                                                        </>
                                                    }}
                                                </rsuite.Table.Cell>
                                            </rsuite.Table.Column>
                                        </rsuite.Table>
                                        <rsuite.Row>
                                            <rsuite.Col xs={24} className='fw-bold text-start'>
                                                {PaymentList.filter(o => o.PayType == 1 && o.status == "EDIT").length > 0 && PaymentList.filter(o => o.PayType == 1 && o.status == "EDIT")[0].Price != "0" ? <>{PN.convert(PaymentList.filter(o => o.PayType == 1 && o.status == "EDIT")[0].Price.replaceAll(',', ''))} ریال</> : ""}

                                            </rsuite.Col>
                                        </rsuite.Row>
                                    </rsuite.Tabs.Tab>)}
                                {(DOCSettingType != 6 && DOCSettingType != 5 && DOCSettingType != 0) && (
                                    < rsuite.Tabs.Tab eventKey="5" title="چک شخصی">
                                        <rsuite.Table height={PaymentList.filter(o => o.PayType == 5).length < 3 ? 160 : PaymentList.filter(o => o.PayType == 5).length >= 3 && PaymentList.filter(o => o.PayType == 5).length < 6 ? PaymentList.filter(o => o.PayType == 5).length * 70 : 320}
                                            data={PaymentList.filter(o => o.PayType == 5)} wordWrap>

                                            <rsuite.Table.Column flexGrow={1} fullText resizable>
                                                <rsuite.Table.HeaderCell>تاریخ ثبت </rsuite.Table.HeaderCell>
                                                <rsuite.Table.Cell >

                                                    {(rowData, rowIndex) => {
                                                        return <>
                                                            {rowData.status == 'EDIT' ? (
                                                                <DatePicker className="rs-input " isGregorian={false}
                                                                    timePicker={false} icon={BiIcon.BiCalendar} value={rowData.PayDate} onChange={value => {
                                                                        Change_Item?.(rowData.row, "PayDate", value, "");
                                                                    }} />
                                                            ) : (
                                                                <text>
                                                                    {rowData.PayDate}
                                                                </text>
                                                            )}
                                                        </>
                                                    }}

                                                </rsuite.Table.Cell>



                                            </rsuite.Table.Column>
                                            <rsuite.Table.Column flexGrow={1} fullText resizable>
                                                <rsuite.Table.HeaderCell>ساعت ثبت </rsuite.Table.HeaderCell>
                                                <rsuite.Table.Cell >

                                                    {(rowData, rowIndex) => {
                                                        return <>

                                                            {rowData.status == 'EDIT' ? (



                                                                <rsuite.TimePicker block onChange={value => {
                                                                    Change_Item?.(rowData.row, "PayTime", value, "");
                                                                }} value={rowData.PayTime} />

                                                            ) : (
                                                                <text>
                                                                    {rowData.PayTime}
                                                                </text>
                                                            )}
                                                        </>
                                                    }}

                                                </rsuite.Table.Cell>


                                            </rsuite.Table.Column>
                                            <rsuite.Table.Column flexGrow={2} fullText resizable>
                                                <rsuite.Table.HeaderCell> بانک </rsuite.Table.HeaderCell>
                                                <rsuite.Table.Cell >

                                                    {(rowData, rowIndex) => {
                                                        return <>

                                                            {rowData.status == 'EDIT' ? (


                                                                <Drp_Bank value={rowData.BankAccountId} onChange={(value, text) => {
                                                                    Change_Item?.(rowData.row, "BankAccount", value, text);
                                                                }} ref={CheckBankRef} />


                                                            ) : (
                                                                <text>
                                                                    {rowData.BankAccount}
                                                                </text>
                                                            )}
                                                        </>
                                                    }}

                                                </rsuite.Table.Cell>
                                            </rsuite.Table.Column>

                                            <rsuite.Table.Column flexGrow={2} fullText resizable>
                                                <rsuite.Table.HeaderCell> شماره چک  </rsuite.Table.HeaderCell>
                                                <rsuite.Table.Cell >

                                                    {(rowData, rowIndex) => {
                                                        return <>

                                                            {rowData.status == 'EDIT' ? (


                                                                <Drp_CheckBookPage value={rowData.CheckBookPageId} onChange={(value, text) => {
                                                                    Change_Item?.(rowData.row, "CheckBookPage", value, text);
                                                                }} ref={CheckRef} />


                                                            ) : (
                                                                <text>
                                                                    {rowData.CheckNo}
                                                                </text>
                                                            )}
                                                        </>
                                                    }}

                                                </rsuite.Table.Cell>
                                            </rsuite.Table.Column>
                                            <rsuite.Table.Column flexGrow={2} fullText resizable>

                                                <rsuite.Table.HeaderCell>تاریخ سر رسید چک </rsuite.Table.HeaderCell>
                                                <rsuite.Table.Cell >

                                                    {(rowData, rowIndex) => {
                                                        return <>
                                                            {rowData.status == 'EDIT' ? (
                                                                <DatePicker className="rs-input " isGregorian={false}
                                                                    timePicker={false} icon={BiIcon.BiCalendar} value={rowData.PayDate} onChange={value => {
                                                                        Change_Item?.(rowData.row, "CheckDate", value, "");
                                                                    }} />
                                                            ) : (
                                                                <text>
                                                                    {rowData.CheckDate}
                                                                </text>
                                                            )}
                                                        </>
                                                    }}

                                                </rsuite.Table.Cell>
                                            </rsuite.Table.Column>

                                            <rsuite.Table.Column flexGrow={2} fullText resizable>
                                                <rsuite.Table.HeaderCell>  در وجه  </rsuite.Table.HeaderCell>
                                                <rsuite.Table.Cell >

                                                    {(rowData, rowIndex) => {
                                                        return <>

                                                            {rowData.status == 'EDIT' ? (


                                                                <rsuite.Input value={rowData.ByCheck} onChange={(value, text) => {
                                                                    Change_Item?.(rowData.row, "ByCheck", value, text);
                                                                }} />


                                                            ) : (
                                                                <text>
                                                                    {rowData.ByCheck}
                                                                </text>
                                                            )}
                                                        </>
                                                    }}

                                                </rsuite.Table.Cell>
                                            </rsuite.Table.Column>
                                            <rsuite.Table.Column flexGrow={2} fullText resizable>
                                                <rsuite.Table.HeaderCell>  وضعیت چک  </rsuite.Table.HeaderCell>
                                                <rsuite.Table.Cell >

                                                    {(rowData, rowIndex) => {
                                                        return <>

                                                            {rowData.status == 'EDIT' ? (


                                                                <select className="rs-input FocusItem" value={rowData.ConfirmCheck}
                                                                    onChange={value => {
                                                                        Change_Item?.(rowData.row, "ConfirmCheck", value.target.value);
                                                                    }}>
                                                                    <option value="0">چک سنتی</option>
                                                                    <option value="1">چک صبادی ثبت شده</option>
                                                                    <option value="2">چک صیادی ثبت نشده</option>
                                                                </select>


                                                            ) : (
                                                                <text>
                                                                    {rowData.ConfirmCheck == 0 ? "چک سنتی" :
                                                                        rowData.ConfirmCheck == 0 ? "چک صبادی ثبت شده" :
                                                                            "چک صیادی ثبت نشده"}
                                                                </text>
                                                            )}
                                                        </>
                                                    }}

                                                </rsuite.Table.Cell>
                                            </rsuite.Table.Column>

                                            <rsuite.Table.Column flexGrow={2} >
                                                <rsuite.Table.HeaderCell>مبلغ  (ریال)</rsuite.Table.HeaderCell>
                                                <rsuite.Table.Cell >
                                                    {(rowData) => {
                                                        return <>
                                                            {rowData.status == 'EDIT' ? (
                                                                <rsuite.Input value={rowData.Price} onChange={value => {
                                                                    Change_Item?.(rowData.row, "Price", value, "");
                                                                }}

                                                                />
                                                            ) : (
                                                                <text>
                                                                    {PN.sliceNumber(rowData.Price)}
                                                                    <rsuite.Text className='Font10 float-start' as='sub'>{rowData.Price != "0" ? <>{PN.convert(rowData.Price)} ریال</> : ""}</rsuite.Text>

                                                                </text>
                                                            )}
                                                        </>
                                                    }}
                                                </rsuite.Table.Cell>
                                            </rsuite.Table.Column>

                                            <rsuite.Table.Column flexGrow={3} >
                                                <rsuite.Table.HeaderCell>توضیحات</rsuite.Table.HeaderCell>
                                                <rsuite.Table.Cell >
                                                    {(rowData) => {
                                                        return <>
                                                            {rowData.status == 'EDIT' ? (
                                                                <>
                                                                    <rsuite.Input value={rowData.Comment} onChange={value => {
                                                                        Change_Item?.(rowData.row, "Comment", value, "");
                                                                    }}

                                                                    />
                                                                </>

                                                            ) : (
                                                                <text>
                                                                    {rowData.Comment}
                                                                </text>
                                                            )}
                                                        </>
                                                    }}
                                                </rsuite.Table.Cell>
                                            </rsuite.Table.Column>

                                            <rsuite.Table.Column width={100} fixed='right'>
                                                <rsuite.Table.HeaderCell></rsuite.Table.HeaderCell>
                                                <rsuite.Table.Cell>
                                                    {(rowData) => {
                                                        return <>


                                                            {rowData.status != "EDIT" ? <BiIcon.BiEditAlt onClick={() => onEditItem(rowData.row)} className='fs-6 Cursor' />
                                                                :
                                                                <BiIcon.BiSave onClick={() => SaveItem(rowData.row)} className='fs-6 text-success Cursor' />
                                                            }
                                                            &nbsp;&nbsp;&nbsp;
                                                            <BiIcon.BiTrash onClick={() => DeleteItem(rowData.row)} className='fs-6 text-danger Cursor' />
                                                        </>
                                                    }}
                                                </rsuite.Table.Cell>
                                            </rsuite.Table.Column>
                                        </rsuite.Table>
                                        <rsuite.Row>
                                            <rsuite.Col xs={24} className='fw-bold text-start'>
                                                {PaymentList.filter(o => o.PayType == 5 && o.status == "EDIT").length > 0 && PaymentList.filter(o => o.PayType == 5 && o.status == "EDIT")[0].Price != "0" ? <>{PN.convert(PaymentList.filter(o => o.PayType == 5 && o.status == "EDIT")[0].Price.replaceAll(',', ''))} ریال</> : ""}

                                            </rsuite.Col>
                                        </rsuite.Row>
                                    </rsuite.Tabs.Tab>)}
                                {(DOCSettingType != 6 && DOCSettingType != 5 && DOCSettingType != 0) && (
                                    <rsuite.Tabs.Tab eventKey="6" title="چک دریافتی">
                                        <rsuite.Table height={PaymentList.filter(o => o.PayType == 6).length < 3 ? 160 : PaymentList.filter(o => o.PayType == 6).length >= 3 && PaymentList.filter(o => o.PayType == 6).length < 6 ? PaymentList.filter(o => o.PayType == 6).length * 70 : 320}
                                            data={PaymentList.filter(o => o.PayType == 6)} wordWrap>

                                            <rsuite.Table.Column flexGrow={1} fullText resizable>
                                                <rsuite.Table.HeaderCell>تاریخ ثبت </rsuite.Table.HeaderCell>
                                                <rsuite.Table.Cell >

                                                    {(rowData, rowIndex) => {
                                                        return <>
                                                            {rowData.status == 'EDIT' ? (
                                                                <DatePicker className="rs-input " isGregorian={false}
                                                                    timePicker={false} icon={BiIcon.BiCalendar} value={rowData.PayDate} onChange={value => {
                                                                        Change_Item?.(rowData.row, "PayDate", value, "");
                                                                    }} />
                                                            ) : (
                                                                <text>
                                                                    {rowData.PayDate}
                                                                </text>
                                                            )}
                                                        </>
                                                    }}

                                                </rsuite.Table.Cell>



                                            </rsuite.Table.Column>
                                            <rsuite.Table.Column flexGrow={1} fullText resizable>
                                                <rsuite.Table.HeaderCell>ساعت ثبت </rsuite.Table.HeaderCell>
                                                <rsuite.Table.Cell >

                                                    {(rowData, rowIndex) => {
                                                        return <>

                                                            {rowData.status == 'EDIT' ? (



                                                                <rsuite.TimePicker block onChange={value => {
                                                                    Change_Item?.(rowData.row, "PayTime", value, "");
                                                                }} value={rowData.PayTime} />

                                                            ) : (
                                                                <text>
                                                                    {rowData.PayTime}
                                                                </text>
                                                            )}
                                                        </>
                                                    }}

                                                </rsuite.Table.Cell>


                                            </rsuite.Table.Column>
                                            <rsuite.Table.Column flexGrow={2} fullText resizable>
                                                <rsuite.Table.HeaderCell> صندوق </rsuite.Table.HeaderCell>
                                                <rsuite.Table.Cell >

                                                    {(rowData, rowIndex) => {
                                                        return <>

                                                            {rowData.status == 'EDIT' ? (


                                                                <Drp_Fund value={rowData.BankAccountId} onChange={(value, text) => {
                                                                    Change_Item?.(rowData.row, "Fund", value, text);
                                                                }} ref={FundRef} />


                                                            ) : (
                                                                <text>
                                                                    {rowData.Fund}
                                                                </text>
                                                            )}
                                                        </>
                                                    }}

                                                </rsuite.Table.Cell>



                                            </rsuite.Table.Column>


                                            <rsuite.Table.Column flexGrow={2} >
                                                <rsuite.Table.HeaderCell>مبلغ  (ریال)</rsuite.Table.HeaderCell>
                                                <rsuite.Table.Cell >
                                                    {(rowData) => {
                                                        return <>
                                                            {rowData.status == 'EDIT' ? (
                                                                <rsuite.Input value={rowData.Price} onChange={value => {
                                                                    Change_Item?.(rowData.row, "Price", value, "");
                                                                }}

                                                                />
                                                            ) : (
                                                                <text>
                                                                    {PN.sliceNumber(rowData.Price)}
                                                                    <rsuite.Text className='Font10 float-start' as='sub'>{rowData.Price != "0" ? <>{PN.convert(rowData.Price)} ریال</> : ""}</rsuite.Text>

                                                                </text>
                                                            )}
                                                        </>
                                                    }}
                                                </rsuite.Table.Cell>
                                            </rsuite.Table.Column>

                                            <rsuite.Table.Column flexGrow={3} >
                                                <rsuite.Table.HeaderCell>توضیحات</rsuite.Table.HeaderCell>
                                                <rsuite.Table.Cell >
                                                    {(rowData) => {
                                                        return <>
                                                            {rowData.status == 'EDIT' ? (
                                                                <>
                                                                    <rsuite.Input value={rowData.Comment} onChange={value => {
                                                                        Change_Item?.(rowData.row, "Comment", value, "");
                                                                    }}

                                                                    />
                                                                </>

                                                            ) : (
                                                                <text>
                                                                    {rowData.Comment}
                                                                </text>
                                                            )}
                                                        </>
                                                    }}
                                                </rsuite.Table.Cell>
                                            </rsuite.Table.Column>

                                            <rsuite.Table.Column width={100} fixed='right'>
                                                <rsuite.Table.HeaderCell></rsuite.Table.HeaderCell>
                                                <rsuite.Table.Cell>
                                                    {(rowData) => {
                                                        return <>


                                                            {rowData.status != "EDIT" ? <BiIcon.BiEditAlt onClick={() => onEditItem(rowData.row)} className='fs-6 Cursor' />
                                                                :
                                                                <BiIcon.BiSave onClick={() => SaveItem(rowData.row)} className='fs-6 text-success Cursor' />
                                                            }
                                                            &nbsp;&nbsp;&nbsp;
                                                            <BiIcon.BiTrash onClick={() => DeleteItem(rowData.row)} className='fs-6 text-danger Cursor' />
                                                        </>
                                                    }}
                                                </rsuite.Table.Cell>
                                            </rsuite.Table.Column>
                                        </rsuite.Table>
                                        <rsuite.Row>
                                            <rsuite.Col xs={24} className='fw-bold text-start'>
                                                {PaymentList.filter(o => o.PayType == 5 && o.status == "EDIT").length > 0 && PaymentList.filter(o => o.PayType == 5 && o.status == "EDIT")[0].Price != "0" ? <>{PN.convert(PaymentList.filter(o => o.PayType == 5 && o.status == "EDIT")[0].Price.replaceAll(',', ''))} ریال</> : ""}

                                            </rsuite.Col>
                                        </rsuite.Row>
                                    </rsuite.Tabs.Tab>)}

                                {(DOCSettingType != 6 && DOCSettingType != 5 && DOCSettingType != 0) && (
                                    <rsuite.Tabs.Tab eventKey="7" title="انتقال حساب ">
                                        <rsuite.Table height={PaymentList.filter(o => o.PayType == 7).length < 3 ? 160 : PaymentList.filter(o => o.PayType == 7).length >= 3 && PaymentList.filter(o => o.PayType == 7).length < 6 ? PaymentList.filter(o => o.PayType == 7).length * 70 : 320}
                                            data={PaymentList.filter(o => o.PayType == 7)} wordWrap>

                                            <rsuite.Table.Column flexGrow={1} fullText resizable>
                                                <rsuite.Table.HeaderCell>تاریخ ثبت </rsuite.Table.HeaderCell>
                                                <rsuite.Table.Cell >

                                                    {(rowData, rowIndex) => {
                                                        return <>
                                                            {rowData.status == 'EDIT' ? (
                                                                <DatePicker className="rs-input " isGregorian={false}
                                                                    timePicker={false} icon={BiIcon.BiCalendar} value={rowData.PayDate} onChange={value => {
                                                                        Change_Item?.(rowData.row, "PayDate", value, "");
                                                                    }} />
                                                            ) : (
                                                                <text>
                                                                    {rowData.PayDate}
                                                                </text>
                                                            )}
                                                        </>
                                                    }}

                                                </rsuite.Table.Cell>



                                            </rsuite.Table.Column>
                                            <rsuite.Table.Column flexGrow={1} fullText resizable>
                                                <rsuite.Table.HeaderCell>ساعت ثبت </rsuite.Table.HeaderCell>
                                                <rsuite.Table.Cell >

                                                    {(rowData, rowIndex) => {
                                                        return <>

                                                            {rowData.status == 'EDIT' ? (



                                                                <rsuite.TimePicker block onChange={value => {
                                                                    Change_Item?.(rowData.row, "PayTime", value, "");
                                                                }} value={rowData.PayTime} />

                                                            ) : (
                                                                <text>
                                                                    {rowData.PayTime}
                                                                </text>
                                                            )}
                                                        </>
                                                    }}

                                                </rsuite.Table.Cell>


                                            </rsuite.Table.Column>
                                            <rsuite.Table.Column flexGrow={2} fullText resizable>
                                                <rsuite.Table.HeaderCell> صندوق </rsuite.Table.HeaderCell>
                                                <rsuite.Table.Cell >

                                                    {(rowData, rowIndex) => {
                                                        return <>

                                                            {rowData.status == 'EDIT' ? (


                                                                <Drp_Fund value={rowData.BankAccountId} onChange={(value, text) => {
                                                                    Change_Item?.(rowData.row, "Fund", value, text);
                                                                }} ref={FundRef} />


                                                            ) : (
                                                                <text>
                                                                    {rowData.Fund}
                                                                </text>
                                                            )}
                                                        </>
                                                    }}

                                                </rsuite.Table.Cell>



                                            </rsuite.Table.Column>


                                            <rsuite.Table.Column flexGrow={2} >
                                                <rsuite.Table.HeaderCell>مبلغ  (ریال)</rsuite.Table.HeaderCell>
                                                <rsuite.Table.Cell >
                                                    {(rowData) => {
                                                        return <>
                                                            {rowData.status == 'EDIT' ? (
                                                                <rsuite.Input value={rowData.Price} onChange={value => {
                                                                    Change_Item?.(rowData.row, "Price", value, "");
                                                                }}

                                                                />
                                                            ) : (
                                                                <text>
                                                                    {PN.sliceNumber(rowData.Price)}
                                                                    <rsuite.Text className='Font10 float-start' as='sub'>{rowData.Price != "0" ? <>{PN.convert(rowData.Price)} ریال</> : ""}</rsuite.Text>

                                                                </text>
                                                            )}
                                                        </>
                                                    }}
                                                </rsuite.Table.Cell>
                                            </rsuite.Table.Column>

                                            <rsuite.Table.Column flexGrow={3} >
                                                <rsuite.Table.HeaderCell>توضیحات</rsuite.Table.HeaderCell>
                                                <rsuite.Table.Cell >
                                                    {(rowData) => {
                                                        return <>
                                                            {rowData.status == 'EDIT' ? (
                                                                <>
                                                                    <rsuite.Input value={rowData.Comment} onChange={value => {
                                                                        Change_Item?.(rowData.row, "Comment", value, "");
                                                                    }}

                                                                    />
                                                                </>

                                                            ) : (
                                                                <text>
                                                                    {rowData.Comment}
                                                                </text>
                                                            )}
                                                        </>
                                                    }}
                                                </rsuite.Table.Cell>
                                            </rsuite.Table.Column>

                                            <rsuite.Table.Column width={100} fixed='right'>
                                                <rsuite.Table.HeaderCell></rsuite.Table.HeaderCell>
                                                <rsuite.Table.Cell>
                                                    {(rowData) => {
                                                        return <>


                                                            {rowData.status != "EDIT" ? <BiIcon.BiEditAlt onClick={() => onEditItem(rowData.row)} className='fs-6 Cursor' />
                                                                :
                                                                <BiIcon.BiSave onClick={() => SaveItem(rowData.row)} className='fs-6 text-success Cursor' />
                                                            }
                                                            &nbsp;&nbsp;&nbsp;
                                                            <BiIcon.BiTrash onClick={() => DeleteItem(rowData.row)} className='fs-6 text-danger Cursor' />
                                                        </>
                                                    }}
                                                </rsuite.Table.Cell>
                                            </rsuite.Table.Column>
                                        </rsuite.Table>
                                        <rsuite.Row>
                                            <rsuite.Col xs={24} className='fw-bold text-start'>
                                                {PaymentList.filter(o => o.PayType == 5 && o.status == "EDIT").length > 0 && PaymentList.filter(o => o.PayType == 5 && o.status == "EDIT")[0].Price != "0" ? <>{PN.convert(PaymentList.filter(o => o.PayType == 5 && o.status == "EDIT")[0].Price.replaceAll(',', ''))} ریال</> : ""}

                                            </rsuite.Col>
                                        </rsuite.Row>
                                    </rsuite.Tabs.Tab>)}
                            </rsuite.Tabs>





                        </rsuite.Col>



                    </rsuite.Row>
                    <hr />
                    <rsuite.Row className='p-1 Font17  pt-5 mt-5 '>
                        <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24} >
                            <rsuite.Row>

                                <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className='mt-2 '>
                                    <b>مبلغ کل پرداختی : </b> <text>  {PN.sliceNumber(TotalPayment)} ریال </text>
                                    &nbsp;&nbsp;&nbsp;&nbsp;<rsuite.Text className='Font10' as='sub'>{TotalPayment != "0" ? <>{PN.convert(TotalPayment.toString().replaceAll(',', ''))} ریال</> : ""}</rsuite.Text>
                                </rsuite.Col>
                                {/* <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className='mt-2 '>
                                    <b> باقیمانده : </b> <text>  {PN.sliceNumber(RemainPrice)} ریال </text>
                                    &nbsp;&nbsp;&nbsp;&nbsp;<rsuite.Text className='Font10' as='sub'>{RemainPrice != "0" ? <>{PN.convert(RemainPrice.toString().replaceAll(',', ''))} ریال</> : ""}</rsuite.Text>
                                </rsuite.Col> */}

                            </rsuite.Row>
                        </rsuite.Col>
                        <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24} className='Font11' >
                            <rsuite.Row>

                                <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className={TotalHavalePayment == 0 ? "hide" : 'mt-2 '}>
                                    <b>مبلغ کل حواله بانکی : </b> <text>  {PN.sliceNumber(TotalHavalePayment)} ریال </text>
                                    &nbsp;&nbsp;&nbsp;&nbsp;<rsuite.Text className='Font10' as='sub'>{TotalHavalePayment != "0" ? <>{PN.convert(TotalHavalePayment.toString().replaceAll(',', ''))} ریال</> : ""}</rsuite.Text>
                                </rsuite.Col>
                                <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className={TotalPersonalcheckPayment == 0 ? "hide" : 'mt-2 '}>
                                    <b> مبلغ کل چک شخصی : </b> <text>  {PN.sliceNumber(TotalPersonalcheckPayment)} ریال </text>
                                    &nbsp;&nbsp;&nbsp;&nbsp;<rsuite.Text className='Font10' as='sub'>{TotalPersonalcheckPayment != "0" ? <>{PN.convert(TotalPersonalcheckPayment.toString().replaceAll(',', ''))} ریال</> : ""}</rsuite.Text>
                                </rsuite.Col>
                                <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className={TotalcheckPayment == 0 ? "hide" : 'mt-2 '}>
                                    <b> مبلغ کل چک دریافتی : </b> <text>  {PN.sliceNumber(TotalcheckPayment)} ریال </text>
                                    &nbsp;&nbsp;&nbsp;&nbsp;<rsuite.Text className='Font10' as='sub'>{TotalcheckPayment != "0" ? <>{PN.convert(TotalcheckPayment.toString().replaceAll(',', ''))} ریال</> : ""}</rsuite.Text>
                                </rsuite.Col>
                                <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className={TotalFundPayment == 0 ? "hide" : 'mt-2 '}>
                                    <b> مبلغ کل صندوق : </b> <text>  {PN.sliceNumber(TotalFundPayment)} ریال </text>
                                    &nbsp;&nbsp;&nbsp;&nbsp;<rsuite.Text className='Font10' as='sub'>{TotalFundPayment != "0" ? <>{PN.convert(TotalFundPayment.toString().replaceAll(',', ''))} ریال</> : ""}</rsuite.Text>
                                </rsuite.Col>
                                <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className={TotalAccountTransferPayment == 0 ? "hide" : 'mt-2 '}>
                                    <b> مبلغ کل انتقال حساب : </b> <text>  {PN.sliceNumber(TotalAccountTransferPayment)} ریال </text>
                                    &nbsp;&nbsp;&nbsp;&nbsp;<rsuite.Text className='Font10' as='sub'>{TotalAccountTransferPayment != "0" ? <>{PN.convert(TotalAccountTransferPayment.toString().replaceAll(',', ''))} ریال</> : ""}</rsuite.Text>
                                </rsuite.Col>

                            </rsuite.Row>
                        </rsuite.Col>





                    </rsuite.Row>
                    <rsuite.Row>
                        <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                            <rsuite.Divider></rsuite.Divider>

                            <small><b>Enter : </b> اضافه شدن محصول جدید <b> | Tab : </b>  جابه جایی در ستون رو به جلو <b>| Shift+Tab :</b> جابه جایی در ستون رو به عقب <b>| Delete :</b> حذف ستون <b>| Enter :</b> اضافه شدن ستون
                                <b>| ESC :</b> بازگشت به صفحه قبل
                                <b>| Shift+p :</b> پرینت
                            </small>
                        </rsuite.Col>
                    </rsuite.Row>
                </rsuite.Panel >
            </div >


            {/* <DeleteModal ref={DeleteRef} onSubmit={() => BindPayment(HeaderPrice)} /> */}

        </Layout >



    )
}

export default InsertPaymentReceivedIndex;